//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import engconfig from '../../envconfig'
import ContentCard from '~/components/cmscontent/content-card/index.vue'
import NoData from '~/components/no-data/index.vue'
import ctaComponent from '~/components/cmscontent/cta/index.vue'
import mock from '~/mock'
import pNav from '~/components/cmscontent/p-nav/index.vue'
import pFooter from '~/components/cmscontent/p-footer/footer.vue'
import comToHtml from '~/components/cmscontent/comToHtml/index.vue'
import sanitizeHtml from 'sanitize-html'
import downloadDialog from '~/components/cmscontent/download-dialog/index.vue'

import crypto from "crypto-js"
export default {
  components: {
    ContentCard,
    NoData,
    pNav,
    pFooter,
    ctaComponent,
    comToHtml,
    downloadDialog,
  },
  scrollToTop: true,
  async asyncData({ app }) {
    const asyncData = {
      org_id: app.store.state.org_id,
      pType: app.router.history.current.query.pType || '',
      pId: app.router.history.current.query.pId || '',
      gType: app.router.history.current.query.gType || '',
      gId: app.router.history.current.query.gId || '',
      isStatistics: app.router.history.current.query.isStatistics || 1,
    }
    // 获取内容详情信息
    await new Promise((resolve) => {
      app.$api
        .getContentDetail({
          org_id: app.store.state.org_id,
          id: app.router.history.current.params.id,
          is_release: 1,
        })
        .then((res) => {
          console.log('=====', res.data)
          asyncData.contentDetail = res.code === 0 ? res.data : {}
          resolve()
        })
    })
    // 获取首页详情信息，包含各种设置项
    await new Promise((resolve) => {
      app.$api
        .getHomeInfo({
          org_id: app.store.state.org_id,
          is_release: 1,
        })
        .then((res) => {
          asyncData.homeSettingInfo = res.code === 0 ? res.data : {}
          console.log(asyncData.homeSettingInfo);
          resolve()
        })
    })
    await new Promise((resolve) => {
      app.$api
        .getHomeInfo({
          org_id: app.store.state.org_id,
          is_release: 2,
        })
        .then((res) => {
          // console.log('res1==>', res)
          if (res.data.is_domain == 1) {
            if (res.data.domain && res.data.domain.includes('https')) {
              asyncData.host = res.data.domain.replace('https://', '')
              //console.log(asyncData.host)
            } else {
              asyncData.host = res.data.domain
            }
          } else {
            asyncData.host = 'app.beschannels.com'
          }
          resolve()
        })
    })
    // 首页分类
    await new Promise((resolve) => {
      app.$api
        .getHomeNavList({
          org_id: app.store.state.org_id,
        })
        .then((res) => {
          var menuList = [],
            showNum = 7
          if (res.code === 0) {
            const { is_bower_title, bower_title } = asyncData.homeSettingInfo
            // 往里面补充 首页
            menuList = [
              {
                id: -1,
                label: is_bower_title ? bower_title : '首页',
              },
              ...res.data,
            ]
          }
          if (menuList.length > showNum) {
            let menuListCopy = [
              ...menuList.slice(0, showNum),
              {
                id: '-2',
                label: '更多',
                children: [...menuList.slice(showNum)],
              },
            ]
            menuList = [...menuListCopy]
          }
          asyncData.menuList = menuList
          resolve()
        })
    })
    return asyncData
  },
  data() {
    return {
      recommendList: [],
      nodataText: '抱歉，未找到该页面',
      formClick: true,
      customer_id: '',
      pageContentNav: true,
      cdpParams: {},
      link: '',
      downLoadFlag: false,
      showMochatQrcode: false,
      // rightCtas: [1, 2],
      mochat_qrcode_url: ''
     
    }
  },
  head() {
    let baiduUrl = this.httpString(this.contentDetail.seo_track)
    let baiScript = []
    if (baiduUrl) {
      baiScript = [{ src: baiduUrl[0] }]
    }
    return {
      title: this.contentDetail.content_title,
      link: [
        {
          rel: 'icon',
          type: 'image/x-icon',
          href:
            this.homeSettingInfo.is_bower_title &&
            this.homeSettingInfo.ico_image
              ? this.homeSettingInfo.ico_image
              : '',
        },
      ],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.contentDetail.seo_description || '描述',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.contentDetail.seo_keywords || '关键词',
        },
      ],
      script: baiScript,
    }
  },
  computed: {
    $domain() {
      return this.prefixImageUrl(process.env.NODE_ENV)
    },
    hasCta() {
      const { type,right_cta,template,download_setting } = this.contentDetail
      const cta = type == 1 && right_cta.length !== 0
      const blog = type == 2 && template == 2 && download_setting == 1
      // 两种情况：1. 内容类型，有右侧cta内容 2.博客类型，白皮书模板为2
      return cta ||  blog
    },
    cat_background_color() {
      return `background:${this.contentDetail.pill_content};`
    },
    rightCtas() {
      if (this.contentDetail.type == 1) {
        let rightCtas = []
        this.contentDetail.right_cta.forEach((item) => {
          let pType = this.contentDetail.type == 1 ? 'blog' : 'ebook'
          let pId = this.contentDetail.id
          let iframeLink = ''
          if (item.includes('https')) {
            iframeLink = `${item}&pType=${pType}&pId=${pId}&release=2&isStatistics=${this.isStatistics}`
          } else {
            iframeLink = `https://${item}&pType=${pType}&pId=${pId}&release=2&isStatistics=${this.isStatistics}`
          }
          rightCtas.push({ iframeLink })
        })
        return rightCtas
      } else if (this.contentDetail.type == 2) {
        let rightCtas = []
        if (this.contentDetail.template == 2) {
          let pType = this.contentDetail.type == 1 ? 'blog' : 'ebook'
          let pId = this.contentDetail.id
          let gType = this.pType
          let gId = this.pId
          let zType = this.gType
          let zId = this.gId
          let isStatistics = this.isStatistics
          let org_id = this.$store.state.org_id
          let form_id = this.contentDetail.form_id
          let iframeLink = ` ${
            engconfig[process.env.NODE_ENV].API_BASE_URL
          }?org_id=${org_id}&form_id=${form_id}&pType=${pType}&pId=${pId}&gType=${gType}&gId=${gId}&zType=${zType}&zId=${zId}&module=cms&isStatistics=${isStatistics}&downloadUrl=${
            this.contentDetail.download_url
          }`

          rightCtas.push({ iframeLink })
          return rightCtas
        }
        return rightCtas
      } else {
        return []
      }
    },
    iframeLink() {
      let pType = this.contentDetail.type == 1 ? 'blog' : 'ebook'
      let pId = this.contentDetail.id
      let isStatistics = this.isStatistics
      if (
        this.contentDetail.cta_url &&
        this.contentDetail.cta_url.includes('https')
      ) {
        return `${this.contentDetail.cta_url}&pType=${pType}&pId=${pId}&release=1&isStatistics=${isStatistics}`
      } else {
        return `https://${this.contentDetail.cta_url}&pType=${pType}&pId=${pId}&release=1&isStatistics=${isStatistics}`
      }
    },
    // formLink() {
    //   let pType = this.contentDetail.type == 1 ? 'blog' : 'ebook'
    //   let pId = this.contentDetail.id
    //   let gType = this.pType
    //   let gId = this.pId
    //   let zType = this.gType
    //   let zId = this.gId
    //   let isStatistics = this.isStatistics
    //   return `https://${this.host}/${this.getCaption(
    //     this.contentDetail.form_link
    //   )}&downloadUrl=${
    //     this.contentDetail.download_url
    //   }&pType=${pType}&pId=${pId}&gType=${gType}&gId=${gId}&zType=${zType}&zId=${zId}&module=cms&isStatistics=${isStatistics}`
    // },
    editorContent() {
      let html = this.replaceIframe(
        this.imgSrcReplace(this.contentDetail.content)
      )
      return html
    },
  },
  created() {
    this.recommendList = mock.recommendList
    if (process.browser && this.isStatistics == 1) {
      window.addEventListener(
        'message',
        function (e) {
          //console.log('12345', e)
          if (e.data.customer_id) {
            localStorage.setItem('customer_id', e.data.customer_id)
          }
        },
        false
      )
      this.customer_id = localStorage.getItem('customer_id')
        ? localStorage.getItem('customer_id')
        : ''

      this.myCollect = new window.Collect({
        org_id: this.$store.state.org_id,
        customer_id: this.customer_id,
        module_type: 'cms',
        baseUrl: this.$trackUrl,
        target_type: 'content',
        system_type: 'renew',
      })
      this.myCollect.init({
        page_view_auto: false,
        element_click_auto: false,
        events: ['BUTTON'],
      })
    }

    
  },
  mounted() {
    if (this.isStatistics == 1) {
      let params = {
        // parent_page_id: this.pId,
        page_id: this.contentDetail.id, // 必传 页面id
        page_first_title: this.contentDetail.content_title, // 可传 页面一级标题
        source_title: this.contentDetail.type == 1 ? 'blog' : 'ebook', // 可传 页面来源
        module_type: 'cms',
        target_type: 'content',
        system_type: 'renew',
        // ...getUtmJson(window.location, 'link'),
      }

      this.myCollect.$visit(params)
      // console.log(params)
    }
    this.splicingLinkParams()
  },
  beforeMount() {},
  methods: {
    getMochatCodeByUser(){
      const {utm_campaign,utm_source,utm_medium,utm_term,utm_content,wechat} = this.$route.query
      let params = {
        orgId: this.org_id,
        code_id: this.contentDetail.mochat_code_info.mochat_code_id || '',
        mobile:'',
        unionid:localStorage.getItem(wechat+'wechat_unionid'),
        open_id:localStorage.getItem(wechat+'wechat_openid'),
        fingerprint_id: localStorage.getItem('fingerprintId'),
        utm_campaign: utm_campaign || '',
        utm_source: utm_source || '',
        utm_medium: utm_medium || '',
        utm_term: utm_term || '',
        utm_content: utm_content || '',
        app_type: '6',// 6 白皮书
        app_id: this.contentDetail.id,
        app_link: encodeURIComponent(window.location.href),
        app_file_link: encodeURIComponent(this.contentDetail.download_url),
        app_name: this.contentDetail.content_title,
      }
      const sign = crypto.MD5(JSON.stringify(params) + 'jvmzISMCzQeP0BB7ocnSN8nnadBcqQjN').toString()
      params.sign = sign
      this.$api
        .getMochatCodeByUser(params)
        .then((res) => {
          if(res.code == 200){
            this.mochat_qrcode_url = res.data.qrcode_url
            this.showMochatQrcode = true
          }else{
            // this.$zqMessage.error(res.msg);
            this.download(this.contentDetail.download_url)
          }
        })
    },
    showMochatDialog(){
      if(!this.mochat_qrcode_url){
        this.getMochatCodeByUser()
      }else{
        this.showMochatQrcode = true
      }
    },
    handleCloseMochatDialog(){
      const { continue_exec } = this.contentDetail.mochat_code_info
      if(continue_exec){
        this.download(this.contentDetail.download_url)
      }
      this.showMochatQrcode = false
    },
    //通知下载
    //父子组件通信
    cdpMessage(data) {
      if (data.type == 'cdpDownload') {
        // if (
        //   this.contentDetail.download_resource &&
        //   this.contentDetail.download_resource.length > 1
        // ) {
        //   this.downLoadFlag = true
        // } else {
        //   this.download(this.contentDetail.download_url)
        // }
        this.download(this.contentDetail.download_url)
      }
    },
    changeVis(val) {
      this.downLoadFlag = val
    },
    imageServerDomain() {
      return engconfig[process.env.NODE_ENV].VUE_APP_DOMAIN
    },
    apiBaseUrl() {
      return engconfig[process.env.NODE_ENV].API_BASE_URL
    },
    //拼接连接参数
    splicingLinkParams() {
      let pType = this.contentDetail.type == 1 ? 'blog' : 'ebook'
      let pId = this.contentDetail.id
      let gType = this.pType
      let gId = this.pId
      let zType = this.gType
      let zId = this.gId
      let isStatistics = this.isStatistics
      let org_id = this.$store.state.org_id
      let form_id = this.contentDetail.form_id
      this.link = `${
        engconfig[process.env.NODE_ENV].API_BASE_URL
      }?org_id=${org_id}&form_id=${form_id}&pType=${pType}&pId=${pId}&gType=${gType}&gId=${gId}&zType=${zType}&zId=${zId}&module=cms&isStatistics=${isStatistics}&downloadUrl=${
        this.contentDetail.download_url
      }`
      this.handleParams(this.link)
    },
    handleParams(url) {
      var paramObj = {}
      if (url.indexOf('?') > -1) {
        var _url = url.split('?')[1].split('#')[0]
        var strArr = _url.split('&')
        strArr.forEach((ele) => {
          var key = ele.split('=')[0]
          var val = ele.split('=')[1]
          paramObj[key] = val
        })
      }
      this.cdpParams = Object.assign({}, paramObj, {
        templateType: this.contentDetail.template || '',
      })
    },
    handleParams1(url) {
      var paramObj = {}
      if (url.indexOf('?') > -1) {
        var _url = url.split('?')[1].split('#')[0]
        var strArr = _url.split('&')
        strArr.forEach((ele) => {
          var key = ele.split('=')[0]
          var val = ele.split('=')[1]
          paramObj[key] = val
        })
      }
      return paramObj
    },
    getCaption(obj) {
      var index = obj.indexOf('/sub-cdp') //获取-后边的字符串
      obj = obj.substring(index + 1, obj.length)
      //  console.log(obj);
      return obj
    },
    getCaption1(obj) {
      var index = obj.indexOf('/web-mobile') //获取-后边的字符串
      obj = obj.substring(index + 1, obj.length)
      //  console.log(obj);
      return obj
    },

    openForm() {
      this.formClick = false
    },
    closeForm() {
      this.formClick = true
    },
    imgSrcReplace(htmlstr) {
      let pType = this.contentDetail.type == 1 ? 'blog' : 'ebook'
      let pId = this.contentDetail.id
      let newHtmlstr = htmlstr

      // newHtmlstr = newHtmlstr.replace(/<span[^>]*>/gi, '<span>');
      let ctaLink = []
      let contentLink = []
      let regex3 = new RegExp(/<iframe [^>]*src=['"]([^'"]+)[^>]*>/gi)
      let regex4 = new RegExp(/<a [^>]*href=['"]([^'"]+)[^>]*>/gi)
      let regexDataType = new RegExp(
        /<iframe [^>]*data-type=['"]([^'"]+)[^>]*>/gi
      )
      let regexContent = new RegExp(/<a [^>]*data-cms=['"]([^'"]+)[^>]*>/gi)

      htmlstr.replace(regexDataType, function (match, capture) {
        if (capture == 'CTA') {
          match.replace(regex3, function (match, url) {
            ctaLink.push(url)
          })
        }
      })
      htmlstr.replace(regexContent, function (match, capture) {
        if (capture == 'cms') {
          match.replace(regex4, function (match, url) {
            contentLink.push(url)
          })
        }
      })
      ctaLink.forEach((item) => {
        let ctaLink = `${item}&pType=${pType}&pId=${pId}&release=1&isStatistics=${this.isStatistics}`
        newHtmlstr = newHtmlstr.replace(item, ctaLink.replace('&amp;', '&'))
      })
      contentLink.forEach((item) => {
        let cmsLink = `${item}&pType=${pType}&pId=${pId}&release=1&isStatistics=${this.isStatistics}`
        newHtmlstr = newHtmlstr.replace(item, cmsLink)
      })
      let _newHtmlstr = newHtmlstr
        .replace(/<span[^>]*>/gi, '<span>')
        .replace(/<br[^>]*>/gi, '<customtag>')
        .replace(/<b[^>]*>/gi, '<b>')
        .replace(/<customtag[^>]*>/gi, '<br>')

        .replace(/<strong[^>]*>/gi, '<strong>')

      return sanitizeHtml(_newHtmlstr, {
        allowedTags: false,
        allowedAttributes: false,
      })
    },
    //去掉iframe
    replaceIframe(str) {
      return str.replace(
        /<iframe\s[^>]*src=["']([^\s"']+)[^>]*>[^<]*<\/iframe>/gi,
        ($0, $1) => {
          // console.log($1) //src链接值
          return `<CtaComponent ctaLink="${$1}"></CtaComponent>`
        }
      )
    },
    //返回首页
    onGetMenu(item) {
      sessionStorage.setItem(
        'postVal',
        JSON.stringify({
          item: item,
          name: this.$refs.pNav.searchVal,
        })
      )
      let classification = item.id > 0 ? `?classification=${item.id}` : ''
      let wechat = this.$route.query.wechat ? this.$route.query.wechat : ''
      let wechatFlag = wechat ? `wechat=${wechat}` : ''
      let flag = item.id > 0 ? '&' : '?'
      window.location.href = `${window.location.origin}${classification}${flag}${wechatFlag}`
    },
    download(url) {
      let a = document.createElement('a')
      a.href = url
      a.target = 'downloadFile'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  },
}
